export const AGREE_WITH_LAST_PRIVACY_TERMS_MUTATION = `
  mutation AgreeWithLastPrivacyTerms {
    me {
      agreeWithPrivacyPolicyTerms {
        agreedWithPrivacyPolicy
      }
    }
  }
`;
